import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Component that redirects users to their appropriate dashboard based on their role
 */
const RoleDashboardRedirect: React.FC = () => {
  const { user, loading, isAuthenticated, getDashboardPath } = useAuth();

  // Show loading while auth state is being determined
  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to the appropriate dashboard based on user role
  const dashboardPath = getDashboardPath();
  return <Navigate to={dashboardPath} replace />;
};

export default RoleDashboardRedirect;